<template>
  <component
    :is="type"
    class="wrapper"
    background="theme.colors.brand.grayLight"
    v-chakra="{
      '@media print': {
        background: 'white',
        marginTop: '0px !important',
        height: '100vh',
      },
    }"
    ><slot
  /></component>
</template>

<script>
/**
 * Used to build the outer wrapper of a page, including the page title and
 * associated actions. Wrapper doesn’t provide customizable options.
 */
export default {
  name: "Wrapper",
  status: "ready",
  release: "1.0.0",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div",
    },
  },
};
</script>

<style lang="scss">
@import "../../design-system/assets/tokens/tokens";
.wrapper {
  padding: 0 $space-s $space-m;
  margin-top: 47px;
  font-family: $font-text;
  line-height: $line-height-m;
  width: 100%;
  @media (min-width-for("md")) {
    margin-top: 47px;
    padding: 0 $space-m $space-m;
    width: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 2;
    flex-shrink: 1;
  }
  @media (min-width-for("lg")) {
    margin-top: 51px;
    padding: 0 $space-m $space-l;
  }
  .full-width-inside-wrapper {
    margin-left: -$space-s;
    margin-right: -$space-s;
    @media (min-width-for("md")) {
      margin-left: -$space-m;
      margin-right: -$space-m;
    }
  }
}
.login .wrapper {
  margin-top: 0;
  padding-bottom: 0;
}
</style>
